import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { REV_BASIC_Schema } from './REV_BASIC_Schema';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(REV_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Dashboard', 'getRevBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Dashboard.getRevBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch4 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(REV_BASIC_Schema.mapper.search4);

  const query = useQuery({
    queryKey: ['Dashboard', 'getRevBasicR4', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Dashboard.getRevBasicR4, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(REV_BASIC_Schema.mapper.search2, context);
    return await apiRequest('post', Global.urls.Dashboard.getRevBasicR2, params);
  }, successOptions);
};

export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(REV_BASIC_Schema.mapper.search3, context);
    return await apiRequest('post', Global.urls.Dashboard.getRevBasicR3, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.save1);
    return await apiRequest('post1', Global.urls.Dashboard.saveRevBasicU1, payload);
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.delete1);
    return await apiRequest(
      'post1',
      Global.urls.Dashboard.deleteRevBasicD1,
      payload
    );
  }, options);
};

export const useSaveFile2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.saveFile2);
    return await apiRequest(
      'post1',
      Global.urls.Dashboard.saveRevBasicFileU2,
      payload
    );
  }, options);
};

export const useDeleteFile1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.deleteFile1);
    return await apiRequest(
      'post1',
      Global.urls.Dashboard.deleteRevBasicFileD1,
      payload
    );
  }, options);
};

export const useSaveActivity3 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.saveActivity3);
    return await apiRequest(
      'post1',
      Global.urls.Dashboard.saveRevBasicActivityU3,
      payload
    );
  }, options);
};

export const useDeleteActivity1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, REV_BASIC_Schema.mapper.deleteActivity1);
    return await apiRequest(
      'post1',
      Global.urls.Dashboard.deleteRevBasicActivityD1,
      payload
    );
  }, options);
};

